interface WatermarkOptions {
  color?: string;
  opacity?: number;
  layout?: 'diagonal' | 'horizontal';
  fontSize?: number;
  fontFamily?: string;
}

export const generateWatermarkImage = async (
  text: string,
  options: WatermarkOptions = {}
): Promise<ArrayBuffer> => {
  const {
    color = '#cccccc',
    opacity = 0.5,
    layout = 'diagonal', // 'diagonal' or 'horizontal'
    fontSize = 80,
    fontFamily = 'Arial'
  } = options;

  return await new Promise<ArrayBuffer>((resolve, reject) => {
    try {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      if (!ctx) {
        reject(new Error('Failed to get canvas context'));

        return;
      }

      // Calculate dimensions based on text length and size approximation
      // A typical A4 page is ~800px wide (at 96dpi) but we want high res for print.
      // Let's create a large enough canvas to hold the rotated text.
      const width = 1000;
      const height = 1000;
      canvas.width = width;
      canvas.height = height;

      ctx.clearRect(0, 0, width, height);

      // Configure text styles
      ctx.font = `bold ${fontSize * 3}px ${fontFamily}`; // Scale up font for high-res canvas
      ctx.fillStyle = color;
      ctx.globalAlpha = opacity;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';

      // Calculate center
      const cx = width / 2;
      const cy = height / 2;

      ctx.translate(cx, cy);

      if (layout === 'diagonal') {
        ctx.rotate((-45 * Math.PI) / 180);
      }

      ctx.fillText(text, 0, 0);

      // Convert to blob then array buffer
      canvas.toBlob((blob) => {
        if (!blob) {
          reject(new Error('Failed to generate watermark image blob'));

          return;
        }
        void blob
          .arrayBuffer()
          .then((buffer) => {
            resolve(buffer);
          })
          .catch((error) => {
            reject(error);
          });
      }, 'image/png');
    } catch (error) {
      reject(error);
    }
  });
};
